export enum FrameTrackerStates {
    notDownloaded = 0,
    downloadedWithNoData = 1,
    downloadedWithData = 2,
}
